export const laoD = [
  [
    [113.68171136090106, 23.01229268180674, 10],
    [113.68169633908097, 23.012281158280114, 10],
  ],
  [
    [113.68164961273335, 23.01236160491583, 10],
    [113.68163359957953, 23.012351288462323, 10],
  ],
  [
    [113.6815942114693, 23.012436442858267, 10],
    [113.6815787813447, 23.01242539125307, 10],
  ],
  [
    [113.68153406433304, 23.012507472097823, 10],
    [113.68151858384628, 23.012496480998177, 10],
  ],
  [
    [113.68147958193177, 23.012581380420528, 10],
    [113.6814633255265, 23.01257139524176, 10],
  ],
  [
    [113.68142457640052, 23.012656587905646, 10],
    [113.68140900132144, 23.012645711897388, 10],
  ],
  [
    [113.68137101303586, 23.012730833300402, 10],
    [113.68135443666193, 23.012721309516124, 10],
  ],
  [
    [113.6813180339909, 23.012806266167466, 10],
    [113.68130114178403, 23.012797230394032, 10],
  ],
  [
    [113.68127229278, 23.01288537541732, 10],
    [113.68125505488185, 23.012876917537152, 10],
  ],
  [
    [113.68122676948227, 23.012964863168147, 10],
    [113.68120920804772, 23.012956996231807, 10],
  ],
  [
    [113.68118347637673, 23.01304599993704, 10],
    [113.68116611095999, 23.013037768572968, 10],
  ],
  [
    [113.68113926042561, 23.013126371605676, 10],
    [113.68112179376735, 23.01311832586373, 10],
  ],
  [
    [113.68109693975211, 23.01320681733197, 10],
    [113.68107875859681, 23.0132002667816, 10],
  ],
  [
    [113.68106052958734, 23.013290865850536, 10],
    [113.68104257915243, 23.013283791027078, 10],
  ],
  [
    [113.68102247151803, 23.0133728169721, 10],
    [113.68100372652255, 23.0133678099627, 10],
  ],
  [
    [113.68099231155651, 23.013459388328002, 10],
    [113.6809741114094, 23.01345288304427, 10],
  ],
  [
    [113.68096024447559, 23.01354393539472, 10],
    [113.68094159699903, 23.013538625458807, 10],
  ],
  [
    [113.68093254519297, 23.013630249518812, 10],
    [113.68091375102752, 23.013625402902154, 10],
  ],
  [
    [113.6809051950814, 23.01371693087965, 10],
    [113.68088641178709, 23.01371204824572, 10],
  ],
  [
    [113.68088162167159, 23.01380421510462, 10],
    [113.6808627082763, 23.013799783608906, 10],
  ],
  [
    [113.68085893055081, 23.013891549025065, 10],
    [113.68083980370842, 23.013887987951918, 10],
  ],
  [
    [113.68083655653167, 23.013980955030373, 10],
    [113.68081834920547, 23.01397446681544, 10],
  ],
  [
    [113.68081265696885, 23.01406593970196, 10],
    [113.68079342652089, 23.014062893903812, 10],
  ],
  [
    [113.680794111375, 23.0141550356667, 10],
    [113.68077513348476, 23.014150846900254, 10],
  ],
  [
    [113.680771204441, 23.014242179427598, 10],
    [113.68075198297205, 23.01423908531285, 10],
  ],
  [
    [113.68074978433134, 23.01433105218555, 10],
    [113.68073100848383, 23.01432614479289, 10],
  ],
  [
    [113.68072053777526, 23.014417371495778, 10],
    [113.68070198539941, 23.01441178306584, 10],
  ],
  [
    [113.68068451761303, 23.014500756689557, 10],
    [113.68066600176805, 23.014495065363096, 10],
  ],
  [
    [113.68065241018192, 23.014586788096622, 10],
    [113.6806344595906, 23.014579713241925, 10],
  ],
  [
    [113.68061231885828, 23.01467010828519, 10],
    [113.6805952725552, 23.014661323597085, 10],
  ],
  [
    [113.68056437789456, 23.014748784070623, 10],
    [113.6805475561782, 23.014739635931083, 10],
  ],
  [
    [113.68051216914074, 23.014825782161285, 10],
    [113.68049614502611, 23.014815479917303, 10],
  ],
  [
    [113.68045593841109, 23.014900215976702, 10],
    [113.68044059520825, 23.01488906083244, 10],
  ],
  [
    [113.68039448165705, 23.0149706877121, 10],
    [113.68037957977042, 23.014959031199968, 10],
  ],
  [
    [113.68032946752687, 23.015038791603676, 10],
    [113.68031548496612, 23.015026196874196, 10],
  ],
  [
    [113.68026159337592, 23.0151035270086, 10],
    [113.68024748122215, 23.015091056735326, 10],
  ],
  [
    [113.6801943974652, 23.0151686799743, 10],
    [113.68017995903476, 23.015156533942722, 10],
  ],
  [
    [113.68012888350235, 23.015235503452757, 10],
    [113.6801143600002, 23.015223444632706, 10],
  ],
  [
    [113.68006378155661, 23.015302920018886, 10],
    [113.68004944188985, 23.015290674131407, 10],
  ],
  [
    [113.67999643179226, 23.015368573572324, 10],
    [113.67998247862735, 23.015355950908667, 10],
  ],
  [
    [113.67992768178, 23.015433220179517, 10],
    [113.67991437309645, 23.01542001464312, 10],
  ],
  [
    [113.67985886961678, 23.015495637110472, 10],
    [113.67984413189605, 23.015483803052703, 10],
  ],
  [
    [113.6797922987776, 23.01556136891909, 10],
    [113.67977740367718, 23.0155497049076, 10],
  ],
  [
    [113.6797262524264, 23.015628562400124, 10],
    [113.67971238503478, 23.015615858979647, 10],
  ],
  [
    [113.67966146124016, 23.015692306393856, 10],
    [113.67964419484238, 23.015683897848888, 10],
  ],
  [
    [113.67961639410323, 23.015771213844896, 10],
    [113.67959848337634, 23.015764052610244, 10],
  ],
  [
    [113.67957739046804, 23.01585349439946, 10],
    [113.67955921857697, 23.015846921022703, 10],
  ],
  [
    [113.67953770793649, 23.01593704918705, 10],
    [113.67952052840752, 23.015928489489866, 10],
  ],
  [
    [113.67948274658166, 23.016013709495063, 10],
    [113.67946830879451, 23.016001562718355, 10],
  ],
  [
    [113.67941830040041, 23.01608150126781, 10],
    [113.67940391050986, 23.01606930588251, 10],
  ],
  [
    [113.67934991189505, 23.016146215046945, 10],
    [113.67933606487009, 23.016133492556644, 10],
  ],
  [
    [113.67928140120878, 23.0162103506026, 10],
    [113.67926740114174, 23.0161977724346, 10],
  ],
  [
    [113.679213533805, 23.016275220528353, 10],
    [113.67919954175356, 23.01626263471425, 10],
  ],
  [
    [113.67914519927089, 23.016339766677486, 10],
    [113.67913132232752, 23.016327072130665, 10],
  ],
  [
    [113.67907758063782, 23.01640451981529, 10],
    [113.6790633560821, 23.01639215931959, 10],
  ],
  [
    [113.67900977939725, 23.016470006178196, 10],
    [113.67899619636601, 23.016457042108957, 10],
  ],
  [
    [113.6789402483925, 23.016532532734463, 10],
    [113.67892581908502, 23.01652037727227, 10],
  ],
  [
    [113.67887197722649, 23.016597401804738, 10],
    [113.67885808623159, 23.016584720408307, 10],
  ],
  [
    [113.6788051039786, 23.01666264866828, 10],
    [113.6787907763064, 23.01665039061599, 10],
  ],
  [
    [113.67873775899984, 23.01672829625947, 10],
    [113.67872379339802, 23.016715685256163, 10],
  ],
  [
    [113.6786697556947, 23.016792994633803, 10],
    [113.67865574398428, 23.016780427523184, 10],
  ],
  [
    [113.67860188846069, 23.016857848241045, 10],
    [113.67858786609668, 23.016845291309632, 10],
  ],
  [
    [113.6785341414652, 23.016922668335067, 10],
    [113.67851995696083, 23.016910268413465, 10],
  ],
  [
    [113.6784670217414, 23.01698860036074, 10],
    [113.6784532829886, 23.016975777612608, 10],
  ],
  [
    [113.67839670164484, 23.017051309872897, 10],
    [113.67838314642655, 23.01703832083393, 10],
  ],
  [
    [113.67832951179015, 23.017115780844463, 10],
    [113.6783150014538, 23.01710370824816, 10],
  ],
  [
    [113.67826230275942, 23.017181941631865, 10],
    [113.67824862512086, 23.01716906300855, 10],
  ],
  [
    [113.67819346788642, 23.017245512551902, 10],
    [113.6781793591699, 23.017233038734965, 10],
  ],
  [
    [113.6781259390476, 23.017310905025976, 10],
    [113.6781120776455, 23.017298195848504, 10],
  ],
  [
    [113.67805702946697, 23.017374925765864, 10],
    [113.6780432833633, 23.01736210973443, 10],
  ],
  [
    [113.6779896974158, 23.017439339080344, 10],
    [113.67797504100844, 23.01742741859132, 10],
  ],
  [
    [113.6779213581189, 23.017504148628735, 10],
    [113.67790731039021, 23.01749161594907, 10],
  ],
  [
    [113.67785461193557, 23.017569565435654, 10],
    [113.67784014260207, 23.017557450698003, 10],
  ],
  [
    [113.67779030285139, 23.0176361565612, 10],
    [113.67777450631792, 23.017625557030406, 10],
  ],
  [
    [113.67774363327071, 23.01771098168314, 10],
    [113.67772493005388, 23.017705840687317, 10],
  ],
  [
    [113.67772269638752, 23.017794479046554, 10],
    [113.67770355196498, 23.017797960824097, 10],
  ],
  [
    [113.67775188480638, 23.017874452594338, 10],
    [113.67773734034671, 23.017886490040954, 10],
  ],
  [
    [113.67782133042734, 23.0179330099855, 10],
    [113.67781065595418, 23.017948126919777, 10],
  ],
  [
    [113.67790023192855, 23.01798625489916, 10],
    [113.67788917091147, 23.0180011318328, 10],
  ],
  // [
  //   [113.67797880000637, 23.018039519926575, 10],
  //   [113.67796791092601, 23.018054505146996, 10],
  // ],
  // [
  //   [113.67805982802034, 23.018090239232077, 10],
  //   [113.67804846879663, 23.0181049223806, 10],
  // ],
  // [
  //   [113.67813907260066, 23.018143001336703, 10],
  //   [113.67812761055144, 23.01815761586228, 10],
  // ],
  // [
  //   [113.67821894938692, 23.01818861729041, 10],
  //   [113.67821327928515, 23.01820589743737, 10],
  // ],
  // [
  //   [113.67830847861438, 23.018204201886462, 10],
  //   [113.6783136004415, 23.018221628105856, 10],
  // ],
  // [
  //   [113.67839331685671, 23.01816959031613, 10],
  //   [113.67840427820389, 23.018184530332306, 10],
  // ],
  // [
  //   [113.67847202512893, 23.018117666312193, 10],
  //   [113.67848434317604, 23.018131671436866, 10],
  // ],
  // [
  //   [113.6785482414953, 23.018061624260078, 10],
  //   [113.67856080450565, 23.01807544168574, 10],
  // ],
  // [
  //   [113.67862474988773, 23.018005576603137, 10],
  //   [113.67863707026417, 23.018019579964765, 10],
  // ],
  // [
  //   [113.67870082615678, 23.017948186413317, 10],
  //   [113.67871221068373, 23.01796285275411, 10],
  // ],
  // [
  //   [113.67877964504213, 23.017895540649718, 10],
  //   [113.67879152621947, 23.017909865494, 10],
  // ],
  // [
  //   [113.67885649129335, 23.017840169366153, 10],
  //   [113.67886863322155, 23.01785430563166, 10],
  // ],
  // [
  //   [113.6789324275089, 23.01778403256724, 10],
  //   [113.67894513607712, 23.01779773544925, 10],
  // ],
  // [
  //   [113.6790070465876, 23.017725385818807, 10],
  //   [113.67901922422126, 23.017739495737175, 10],
  // ],
  // [
  //   [113.67908037198112, 23.017667422161047, 10],
  //   [113.67909406211969, 23.017680289444904, 10],
  // ],
  // [
  //   [113.67915015833317, 23.017604218161775, 10],
  //   [113.67916372956289, 23.017617192917758, 10],
  // ],
  // [
  //   [113.67922029734395, 23.01754151969015, 10],
  //   [113.67923393345157, 23.017554436026664, 10],
  // ],
  // [
  //   [113.67929004414029, 23.017478150825895, 10],
  //   [113.67930342061123, 23.017491297719097, 10],
  // ],
  // [
  //   [113.6793618273345, 23.017416734017985, 10],
  //   [113.67937488969889, 23.017430148791334, 10],
  // ],
  // [
  //   [113.67943446099922, 23.017356397787907, 10],
  //   [113.67944746075021, 23.017369864569066, 10],
  // ],
];
